import { findAndReplace, ReplaceFunction } from "hast-util-find-and-replace"
import { u } from "unist-builder"

import { MentionableSuggestion } from "@components/chat/channel/trigger/hooks/useMentionTrigger"
import type { Nodes } from "hast-util-find-and-replace/lib"

export const customMentionsMarkdownPlugin =
  (mentioned_groups: MentionableSuggestion[]) => () => {
    const hasAtChannelMention = mentioned_groups.find((g) => g.name === "channel")
    const atChannelMentionRegex = RegExp(`@channel`, "g")

    // Wrap mention around the @channel mention
    const replace: ReplaceFunction = (match) =>
      u(
        "element",
        {
          properties: {},
          tagName: "mention",
          mentionedGroup: { name: "channel" },
        },
        [u("text", match)]
      )

    return (tree: Nodes) => {
      if (!hasAtChannelMention) return
      findAndReplace(tree, [atChannelMentionRegex, replace])
    }
  }
